import { render, staticRenderFns } from "./OutcomeScreen.vue?vue&type=template&id=71a5599b"
import script from "./OutcomeScreen.vue?vue&type=script&lang=js"
export * from "./OutcomeScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports